import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    success: { type: String, default: "Saved" },
    error: { type: String, default: "Could not save" },
    refreshFrames: { type: Array, default: [] }
  };

  connect() {
    this._boundOnSubmitEnd = this._onSubmitEnd.bind(this);
    this._boundCheckDirty = this._checkDirty.bind(this);
    this.element.addEventListener("turbo:submit-end", this._boundOnSubmitEnd);
    this.element.addEventListener("input", this._boundCheckDirty);
    this.element.addEventListener("change", this._boundCheckDirty);
    this._snapshot = this._captureValues();
    this._setSubmitDisabled(true);
  }

  disconnect() {
    this.element.removeEventListener(
      "turbo:submit-end",
      this._boundOnSubmitEnd
    );
    this.element.removeEventListener("input", this._boundCheckDirty);
    this.element.removeEventListener("change", this._boundCheckDirty);
  }

  _onSubmitEnd(event) {
    if (event.detail.success) {
      toastr.success(this.successValue);
      this._snapshot = this._captureValues();
      this._setSubmitDisabled(true);
      this.refreshFramesValue.forEach((id) => {
        const frame = document.getElementById(id);
        if (frame) frame.src = window.location.href;
      });
    } else {
      toastr.error(this.errorValue);
    }
  }

  _checkDirty() {
    const dirty =
      this._serialize(this._captureValues()) !==
      this._serialize(this._snapshot);
    this._setSubmitDisabled(!dirty);
  }

  // elements (not querySelectorAll) also picks up form="..." fields outside
  // the form's DOM subtree; values are arrays since repeated names (e.g.
  // "order_ids[]") shouldn't collapse to a single last value.
  _captureValues() {
    const map = new Map();
    for (const el of this.element.elements) {
      if (!el.name) continue;
      const values = map.get(el.name) || [];
      values.push(el.value);
      map.set(el.name, values);
    }
    return map;
  }

  _serialize(map) {
    return JSON.stringify([...map.entries()].sort());
  }

  _setSubmitDisabled(disabled) {
    this._submitButtons.forEach((btn) => {
      btn.disabled = disabled;
    });
  }

  get _submitButtons() {
    const internal = [...this.element.querySelectorAll('[type="submit"]')];
    const id = this.element.id;
    const external = id
      ? [...document.querySelectorAll(`[form="${id}"][type="submit"]`)]
      : [];
    return [...new Set([...internal, ...external])];
  }
}
